import React from 'react';
import styles from './NetWorth.module.css';
// import Chart from '../../../../../Utils/Charts/NotLinkedCharts/Chart';
import { Card } from '@mui/material';
import { Link } from 'react-router-dom';
import useWindowDimensions from '../../../../../Reusables/VisualAndAccord/Hooks/useWindowDimensions';
import { ResponsiveLine } from '@nivo/line';

// import { ResponsiveLine } from "@nivo/line";

const NetWorth = () => {
  const myData = [
    {
      data: [
        { x: null, y: '20k' },
        { x: null, y: '30k' },
        { x: null, y: '40k' },
        { x: null, y: '50k' },
        { x: null, y: '60k' },
      ],
    },
  ];

  const { width } = useWindowDimensions();
  return (
    <Card
      className={styles.outerClass}
      style={{
        borderRadius: '10px',
        boxShadow: '3px 3px 10px rgba(0, 0, 0, 0.2)',
      }}
    >
      <div className={styles.header}>
        <div className={styles.headTag}>Net worth</div>
        <div className={styles.amtTag}>$ 00,000</div>
      </div>
      {/* <Chart xLabel="This Month" yLabel="Net Worth" myData={myData} /> */}
      <ResponsiveLine
        data={myData}
        margin={{
          top: width > 576 ? 40 : 30,
          right: width > 576 ? 50 : 30,
          bottom: 80,
          left: width > 576 ? 50 : 50,
        }}
        xScale={{ type: 'linear', min: 0, max: 100 }}
        yScale={{
          type: 'linear',
        }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          orient: 'bottom',
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'This month',
          legendOffset: 46,
          legendPosition: 'middle',
        }}
        axisLeft={{
          orient: 'left',
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'Networth',
          legendOffset: width > 576 ? -45 : -35,
          legendPosition: 'middle',
          tickValues: 5,
        }}
        pointSize={0}
        pointColor={{ theme: 'background' }}
        pointBorderWidth={2}
        pointBorderColor={{ from: 'serieColor' }}
        pointLabel="y"
        pointLabelYOffset={-12}
        useMesh={true}
        enableArea={true}
        areaOpacity={1}
      />
      <div className={styles.center}>
        To view this information, Please{' '}
        <Link to="/auth/linkaccounts">link accounts</Link>
      </div>
    </Card>
  );
};

export default NetWorth;
